export const HOME = '/'
export const RETURN = '/return'